import { getLocale, t } from "@auto/services";
import {
  AGE_LABEL_KEYS,
  CORRECTION_GEOGRAPHY_METRICS,
  SEX_LABEL_KEYS,
  STANDARD_GEOGRAPHY_METRICS,
} from "./reportingConstants.mjs";

const locale = () => getLocale() || undefined;

export const count = (value) => (
  new Intl.NumberFormat(locale()).format(Number(value || 0))
);

export const dateBucket = (value) => {
  if (!value) return "";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(locale(), { month: "short", day: "numeric" });
};

export const sexLabel = (key) => {
  const normalized = String(key || "UNKNOWN").trim().toUpperCase();
  return t(SEX_LABEL_KEYS[normalized] || "stats.unknown");
};

export const ageLabel = (key) => {
  const normalized = String(key || "UNKNOWN").trim().toUpperCase();
  return t(AGE_LABEL_KEYS[normalized] || "stats.unknown");
};

export const geographyLabel = (row) => {
  if (!row) return "";
  const code = String(row.code || "").trim();
  const name = String(row.name || "").trim();
  if (code && name) return `${code} - ${name}`;
  return name || code || String(row.gid || row.id || "");
};

const PERCENT_FORMAT = () => new Intl.NumberFormat(locale(), {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const percent = (value) => value === null || value === undefined
  ? "—"
  : `${PERCENT_FORMAT().format(Number(value))}%`;

export const labelOf = geographyLabel;

export const geographyMetrics = (correction) => (
  correction ? CORRECTION_GEOGRAPHY_METRICS : STANDARD_GEOGRAPHY_METRICS
);

export const metricDefinition = (metric, correction = false) => {
  const definitions = geographyMetrics(correction);
  return definitions.find((item) => item.value === metric) || definitions[0];
};

export const metricNumber = (row, metric) => {
  const value = Number(row?.[metric]);
  return Number.isFinite(value) ? value : 0;
};

export const metricDisplay = (value, metric, correction = false) => {
  const definition = metricDefinition(metric, correction);
  if (definition.kind === "percent") return percent(value);
  return count(value);
};

